<template>
  <div class="introduce">
    <div class="introduce__grid">
      <div class="introduce__grid__left">
        <UserAvatar :user="user" />

        <div class="introduce__group">
          <div class="introduce__label">menu do usuário</div>
          <div class="introduce__name">{{ user.name }}</div>
        </div>
      </div>

      <div class="introduce__grid__right">
        <NotificationButton :user="user" />
      </div>
    </div>
  </div>
</template>

<script>
  import UserAvatar from '@/components/user/UserAvatar'
  import NotificationButton from '@/components/notification/NotificationButton'

  export default {
    components: {
      UserAvatar,
      NotificationButton,
    },

    props: {
      user: { type: Object, required: true }
    }
  }
</script>

<style lang="scss" scoped>
  .introduce {
    flex: 1;
    border-radius: 5px;

    &__grid {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;

      & > * { display: flex; align-items: center }

      &__left { flex: 1 }

      &__right {}
    }

    &__group { 
      margin-left: 8px 
    }

    &__label {
      font-size: 0.61rem;
    }

    &__name {
      font-size: 0.77rem;
    }
  }
</style>